<template>
  <div class="desc-page">
    <div v-if="!loading" class="content" v-html="activityInfo.mapStyle.fnModule.activityDesc.activityDesc"></div>
    <div v-if="showBack" @click="back" class="back">返回</div>
  </div>
</template>

<script>
import { getActivityInfo } from '@/server/interfaces'
import { mapMutations } from 'vuex' // mapActions

export default {
  name: 'DescPage',
  data() {
    return {
      loading: true,
      showBack: true,
      activityInfo: null,
      activityId: ''
    }
  },
  created() {
    try {
      this.activityId = this.$route.query.id
      this.showBack = history.length > 1
      this.getActivityInfo()
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
    }),
    back() {
      this.$router.back()
    },
    async getActivityInfo() {
      try {
        this.showLoading()
        const res = await getActivityInfo({ params: { id: this.activityId } })
        if (res) {
          this.activityInfo = res
          this.loading = false
        } else {
          this.toast('活动信息获取失败')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.hideLoading()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.desc-page {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0.32rem;
  overflow: auto;

  .back {
    width: 0.95rem;
    height: 0.66rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0 0.38rem 0.38rem 0;
    position: fixed;
    left: 0;
    top: 32px;
    z-index: 9999;
    transform: translate(0, -50%);
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    line-height: 0.66rem;
    text-align: center;
    color: #ffffff;
  }

  .content {
    ::v-deep {
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>
